module.exports = __webpack_public_path__ + "img/product_109.c89fc82.svg";